import { TemplateQuestionGroupApi } from "@stormwater-software/lib-inspection-templates";
import xhrService from "../api";
import { apiError } from '../apiError';

export const questionGroupApi: TemplateQuestionGroupApi = {
  index: templateId => {
    return xhrService
      .get(`/api/inspection-templates/${templateId}/question-groups`)
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },

  show: (inspectionTemplateId, id) => {
    return xhrService
      .get(
        `/api/inspection-templates/${inspectionTemplateId}/question-groups/${id}`,
      )
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },

  create: (inspectionTemplateId, data) => {
    return xhrService
      .post(
        `/api/inspection-templates/${inspectionTemplateId}/question-groups`,
        data,
      )
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },

  update: (inspectionTemplateId, id, data) => {
    return xhrService
      .put(
        `/api/inspection-templates/${inspectionTemplateId}/question-groups/${id}`,
        data,
      )
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },

  delete: (templateId: number, id: number) => {
    return xhrService
      .delete(`/api/inspection-templates/${templateId}/question-groups/${id}`)
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },

  swap: (
    templateId: number,
    questionGroupId1: number,
    questionGroupId2: number,
  ) => {
    return xhrService
      .put(`/api/inspection-templates/${templateId}/question-groups-swap`, {
        groupId1: questionGroupId1,
        groupId2: questionGroupId2,
      })
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },
};
